import React, { useState, useEffect } from "react";
import { isEmpty } from "../libs/isEmpty";
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import ModalButton from './ModalButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DatasourceModal from './DatasourceModal'
import EditIcon from '@material-ui/icons/Edit';
import { Grid } from "@material-ui/core";
import showStatusKode from "./showStatusKode";
import { useCardStyles } from '../styles/commonStyles';


export default function Datasource({
  ...props
}) {
  const classes = useCardStyles();
  const [isVendorless, setIsVendorless] = useState(true);

  useEffect(() => {
    if (isEmpty(props.vendorMeta)) {
      setIsVendorless(true)
    } else {
      setIsVendorless(false)
    }
  }, [props.vendorMeta])

  const rows = props.sources

  //console.log(rows)
  return (
    <Card
      className={classes.root}
      raised
    >
      <CardContent>
          <Typography className={classes.title} gutterBottom>
            Datastores
          </Typography>
          {isVendorless ? (
            <>
            <ListItem className={classes.listitem} key={"addDatasource"}>
              <ListItemText>
               Der er ikke valgt en profil.
              </ ListItemText>
            </ListItem>        
            </>
          ) : (
            <>
            <Table size="small" className={classes.table} aria-label="datasource-table">
              <TableHead>
                <TableRow>
                  <TableCell>Alias</TableCell>
                  <TableCell align="right">Type</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow key={row.ds_id}>
                    {row.active ? (
                      <>
                      <TableCell component="th" scope="row">{row.alias}</TableCell>
                      <TableCell align="right">{row.store_type}</TableCell>
                      <TableCell align="center">{showStatusKode(row.status_code, row.status_message, row.status_time)}</TableCell>
                      <TableCell align="center">
                      <Grid 
                        container
                        style={{width: 166}}
                        direction="row"
                        alignItems="flex-start"
                        justifyContent="center">
                          <Grid item>
                            <DatasourceModal
                              color="default"
                              id={row.ds_id}
                              values={row}
                              cancelText="Annuller"
                              titleText="Ret datasource"
                              acceptText="Ret"
                              acceptAction={props.edit}
                              btnText={<EditIcon />}
                            />
                          </Grid>
                          <Grid item>
                            <ModalButton
                              btnColor="default"
                              id={row.ds_id}
                              btnText={<DeleteIcon />}
                              acceptAction={() => {props.delete(row.ds_id)}}
                              acceptText="slet"
                              cancelText="fortryd"
                              titleText={"Bekræft sletning af datakilden: " + row.alias}
                              contentText={"Denne handling fjerner datakilden: '" + row.alias + "' tilhørende " + props.vendorMeta.vendor_alias + " uden yderligere varsel. Der vil ikke blive hentet data fra nogen featuretypes der er koblet til denne kilde."}
                            />         
                          </Grid>
                        </Grid>
                      </TableCell>
                      </>
                    ) : (
                      <>
                      <TableCell className={classes.notactive} component="th" scope="row">{row.alias}</TableCell>
                      <TableCell className={classes.notactive} align="right">{row.store_type}</TableCell>
                      <TableCell className={classes.notactive} align="center">{showStatusKode(row.status_code, row.status_message, row.status_time)}</TableCell>
                      <TableCell className={classes.notactive} align="center">
                        <Grid 
                        container
                        style={{width: 166}}
                        direction="row"
                        alignItems="flex-start"
                        justify="center">
                          <Grid item>
                            <DatasourceModal
                              color="default"
                              id={row.ds_id}
                              values={row}
                              cancelText="Annuller"
                              titleText="Ret datasource"
                              acceptText="Ret"
                              acceptAction={props.edit}
                              btnText={<EditIcon />}
                            />
                          </Grid>
                          <Grid item>
                            <ModalButton
                              btnColor="default"
                              id={row.ds_id}
                              btnText={<DeleteIcon />}
                              acceptAction={() => {props.delete(row.ds_id)}}
                              acceptText="slet"
                              cancelText="fortryd"
                              titleText={"Bekræft sletning af datakilden: " + row.alias}
                              contentText={"Denne handling fjerner datakilden: '" + row.alias + "' tilhørende " + props.vendorMeta.vendor_alias + " uden yderligere varsel. Der vil ikke blive hentet data fra nogen featuretypes der er koblet til denne kilde."}
                            />         
                          </Grid>
                        </Grid>
                      </TableCell>
                      </>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <DatasourceModal
              btnText={<AddIcon />}
              titleText="Tilføj datasource"
              values={{}}
              cancelText="Annuller"
              acceptText="Tilføj"
              acceptAction={props.create}
            />
            </>
          )}
          
      </CardContent>
    </Card>
  )
}
